export class CustomerSiteVendor  {
    customersitecode:string
    vendorId: number;
    vendorName: string;
    vendorRates: string;
    vendorStrength: string;
    vendorPainPoint: string;
    isTemp:boolean

}